// extracted by mini-css-extract-plugin
export default {"listItem":"AsideNavItem_listItem__ZbjZT","active":"AsideNavItem_active__sBxO4","total":"AsideNavItem_total__5soSO"};